<template>
    <div>
        <carousel 
            :perPage="3"
            :perPageCustom="[[360, 1], [768, 3]]" 
            :autoplay="true" 
            :speed="1000" 
            :autoplayTimeout="4000" 
            :loop="true" 
            :paginationEnabled="true"
            :centerMode="true"
            :paginationActiveColor="colors.primary"
            paginationColor="#666666"
        >
            <slide>
                <div class="service-info-3">
                    <div class="detail">
                        <img :src="getS3Url('/images/trova_agenzia.png')" class="img-responsive">
                        <h3>Trova l'agenzia</h3>
                        <p>Scopri le migliori agenzie immobiliari di {{ this.capoluogo }} e provincia.</p>
                        <div class="mt-4"><a href="/agenzie-immobiliari" class="call-to-action">Scopri di più</a></div>
                    </div>
                </div>
            </slide>
            <slide>
                <div class="service-info-3">
                    <div class="detail">
                        <img :src="getS3Url('/images/agenzia.png')" class="img-responsive">
                        <h3>Sei un'agenzia?</h3>
                        <p>Promuovi i tuoi immobili ed entra nel nostro circuito.</p>
                        <div class="mt-4"><a href="/servizi-agenzie" class="call-to-action">Scopri di più</a></div>
                    </div>
                </div>
            </slide>
            <slide>
                <div class="service-info-3">
                    <div class="detail">
                        <img :src="getS3Url('/images/cantieri-icona.png')" class="img-responsive">
                        <h3>Cantieri</h3>
                        <p>{{ 'I nuovi interventi in costruzione a ' + capoluogo + ' e provincia' }}</p>
                        <div class="mt-4"><a href="/cantieri" class="call-to-action">Scopri di più</a></div>
                    </div>
                </div>
            </slide>
        </carousel>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        props: ['colors', 'capoluogo'],
        components: {
            Carousel,
            Slide
        },
        methods: {
            getS3Url(path) {
                return process.env.MIX_ASSETS_URL_S3 + path;
            }
        }
    }
</script>
